import { render, staticRenderFns } from "./AbnormalHome.vue?vue&type=template&id=69c97fbb"
import script from "./AbnormalHome.vue?vue&type=script&lang=js"
export * from "./AbnormalHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports